import { CONSOLE_REQUEST_ENABLE, CONSOLE_RESPONSE_ENABLE } from '@/config';

export function requestSuccessFunc(requestObj) {
	CONSOLE_REQUEST_ENABLE && console.info('request', requestObj);

	return requestObj;
}

export function requestFailFunc(requestError) {
	// 自定义发送请求失败逻辑，断网，请求发送监控等

	return Promise.reject(requestError);
}

export function responseSuccessFunc(responseObj) {
	if (CONSOLE_RESPONSE_ENABLE) {
		console.log('response:', responseObj); // temp
	}
	return responseObj.data;
}

export function responseFailFunc(responseError) {
	if (CONSOLE_RESPONSE_ENABLE) {
		console.log(responseError); // temp
	}
	return Promise.reject(responseError);
}
